export const CAPTCHA_SITE_KEY = process.env.REACT_APP_CAPTCHA_SITE_KEY;

export enum AuthErrors {
  LOGIN_ERROR = 'Email or password are invalid.',
  CAPTCHA_ERROR = 'You did not pass captcha.',
  TFA_QR_CODE_ERROR = 'Error with QR code for 2FA',
  TFA_ERROR = 'You didnt pass 2FA'
}
